import { FC } from "react";
import { Progress } from "../ui/progress";
import Badge from "../Badge";
import { Link } from "react-router-dom";

interface ProjectItemProps {
  name: string;
  description: string;
  specsStatus: string;
  progress: number;
  classColor: string;
  id: string;
  className?: string;
}

const ProjectItem: FC<ProjectItemProps> = ({name, description, specsStatus, progress, classColor, id, className}) => {
  const link =
    specsStatus === "NOT_GENERATED"
      ? `/architecture/specs/${id}`
      : `/architecture/preview/${id}`;
  return (
    <Link
      to={link}
      className={`block ${className}`}
    >
      <div className="flex flex-col justify-between gap-2 sm:gap-3 p-3 sm:p-4 bg-white rounded-lg shadow-md min-h-[120px] sm:min-h-[150px] hover:shadow-lg transition-shadow">
        <div className="flex justify-between items-start">
          <h2 className="text-lg sm:text-xl font-semibold text-black leading-tight">{name}</h2>
        </div>
        <p className="text-sm sm:text-base text-[#8F95B2] line-clamp-2">{description}</p>
        <div className="flex flex-col gap-2">
          <div className="flex justify-between items-center gap-2">
            <Progress className={classColor} value={progress} />
            <Badge classColor={classColor} size="md">
              {progress}%
            </Badge>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProjectItem;
